import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Output } from '@angular/core';
import { AnimationEvent } from '@angular/animations';
import { AnimationState, enterLeaveAnimation } from './animation';
import { DrawerOptions } from '@shared/shared/drawers/common/interfaces/drawer-options';

@Component({
  selector: 'eos-browser-drawer',
  templateUrl: './browser-drawer.component.html',
  styleUrls: ['./browser-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [enterLeaveAnimation],
  standalone: false
})
export class BrowserDrawerComponent<T> {
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  protected drawerData?: DrawerOptions<T>;

  protected animationState: keyof typeof AnimationState = AnimationState.hidden;

  @Output() closed: EventEmitter<void> = new EventEmitter<void>();

  openDrawer(drawerData: DrawerOptions<T>): void {
    this.animationState = AnimationState.visible;
    this.drawerData = drawerData;
    this.changeDetectorRef.detectChanges();
  }

  close(): void {
    this.animationState = AnimationState.hidden;
    this.changeDetectorRef.detectChanges();
  }

  onAnimationDone(event: AnimationEvent): void {
    if (event.toState === AnimationState.hidden) {
      this.closed.emit();
    }
  }
}
